module.exports = __webpack_public_path__ + "static/img/1_0028.53822c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tech/1_0028.jpg
// module id = g1pi
// module chunks = 0